module.exports = __webpack_public_path__ + "static/img/3.49328af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/3.jpg
// module id = YNoJ
// module chunks = 1